import React from 'react';
import { getCommonTimezones } from '../utils/dateFormatter';
import './TimezoneSelector.css';

/**
 * TimezoneSelector Component
 * 
 * A dropdown selector for choosing IANA timezone identifiers.
 * Groups timezones by region for better usability.
 * 
 * @param {Object} props
 * @param {string} props.selectedTimezone - Currently selected timezone (IANA identifier)
 * @param {function} props.onTimezoneChange - Callback when timezone changes
 * @param {string} [props.label] - Label for the selector (optional)
 * @param {boolean} [props.required] - Whether the field is required (default: false)
 */
const TimezoneSelector = ({ 
  selectedTimezone, 
  onTimezoneChange, 
  label = "Timezone",
  required = false 
}) => {
  const timezones = getCommonTimezones();

  // Group timezones by region
  const groupedTimezones = timezones.reduce((groups, tz) => {
    const region = tz.value.split('/')[0]; // e.g., "America", "Europe", "Asia"
    if (!groups[region]) {
      groups[region] = [];
    }
    groups[region].push(tz);
    return groups;
  }, {});

  return (
    <div className="timezone-selector-container">
      <select
        id="timezone-select"
        value={selectedTimezone}
        onChange={(e) => onTimezoneChange(e.target.value)}
        className="timezone-select"
        required={required}
      >
        <option value="">-- Select a timezone --</option>
        {Object.entries(groupedTimezones).map(([region, tzList]) => (
          <optgroup key={region} label={region.replace(/_/g, ' ')}>
            {tzList.map((tz) => (
              <option key={tz.value} value={tz.value}>
                {tz.label}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </div>
  );
};

export default TimezoneSelector;
